import { Injectable } from '@angular/core';
import { PermissionsService, VideoFiltersResponse } from '@solverml/api';
import { Observable, of, tap, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterDataService {

  constructor(
    private permissionsService: PermissionsService
  ) { }

  /**
   * Obtiene los filtros de vídeo para el usuario.
   */
  public getVideoFilters(): Observable<VideoFiltersResponse | null> {

    return this.permissionsService.getVideoPermissionFilters()
  }

}
